<template>
  <div class="share-links">
    <a href="javascript:" class="social-share-icon icon-heart" @click="addFavorite()" v-if="showFavorite"></a>
    <slot></slot>
  </div>
</template>

<script>
  require('social-share.js/dist/js/social-share.min');
  require('social-share.js/dist/css/share.min.css');
  /* global socialShare */
  export default {
    name: 'SocialShare',
    mounted() {
      socialShare(this.$el, {
        mode: 'prepend',
        title: this.title,
        image: this.image,
        sites: this.sites,
        mobileSites: this.mobileSites,
        wechatQrcodeTitle: this.wechatQrcodeTitle,
        wechatQrcodeHelper: this.wechatQrcodeHelper,
      });
    },
    props: {
      title: {
        type: String,
        default: '',
      },
      image: {
        type: String,
        default: '',
      },
      wechatQrcodeTitle: {
        type: String,
        default: '微信掃一掃：分享',
      },
      wechatQrcodeHelper: {
        type: String,
        default: '<p>微信里點“發現”，掃一下</p><p>二維碼便可將本文分享至朋友圈。</p>',
      },
      description: {
        type: String,
      },
      sites: {
        type: Array,
        default: () => ['facebook', 'google', 'wechat'],
      },
      mobileSites: {
        type: Array,
        default: () => ['facebook', 'google', 'wechat'],
      },
      showFavorite: Boolean,
    },
    methods: {
      addFavorite() {
        const url = window.location.href;
        const title = this.$t('app.name');
        if (window.external && 'addFavorite' in window.external) {
          window.external.addFavorite(url, title);
        } else if (window.sidebar && window.sidebar.addPanel) {
          window.sidebar.addPanel(url, title);
        } else if (window.opera && window.print) {
          this.title = title;
        } else {
          // eslint-disable-next-line
          alert('Press ' + (navigator.userAgent.toLowerCase().indexOf('mac') != -1 ? 'Command/Cmd' : 'CTRL') + ' + D to bookmark this page.');
        }
      },
    },
  };
</script>
